<template>
  <div class='error-snackbar'>
    <v-snackbar :timeout="6000" top v-model="visible">
      {{ text }}
      <v-btn text class="pink--text" @click.native="visible = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'error-snackbar',

  data () {
    return {
      isActive: this.value,
      text: '',
      visible: false
    }
  },

  props: ['value'],

  watch: {
    value (val) {
      if (val) {
        this.text = val
      }
      this.$emit('input', null)
      this.visible = true
    }
  }
}
</script>
